jQuery(document).ready(function( $ ) {
  const $window = $(window);
  const $document = $(document);
  const $body = $('body');

  const $popupInfo = $('.popup-info');

  $('.js-popup').on('click', function(event) {
    event.preventDefault();

    const $this = $(this);
    const $thisParent = $this.parent();

    const $dataHeadImage = $thisParent.data('head-src');
    const $dataHeadText = $thisParent.data('head-text');
    const $dataHeadSublabel = $thisParent.data('head-sublabel');
    const $dataEntry = $thisParent.data('entry');
    const $dataLink = $this.attr('href');

    if ($window.width() > 1024) {
      $popupInfo.appendTo($thisParent);
    } else {
      $popupInfo.appendTo('.section-graphics');
    }

    $popupInfo.addClass('is-active');
    $popupInfo.find('.popup__head img').attr('src', $dataHeadImage);
    $popupInfo.find('.popup__head .label').text($dataHeadText);
    $popupInfo.find('.popup__head .sublabel').text($dataHeadSublabel);
    $popupInfo.find('.popup__entry p').text($dataEntry);
    $popupInfo.find('.popup__actions a').attr('href', $dataLink);
    $body.addClass('has-active-popup');
  })

  $popupInfo.on('click', function(e) {
    if (!$(this).find('.popup__inner').is(e.target) && $(this).find('.popup__inner').has(e.target).length === 0) {
      $popupInfo.removeClass('is-active');
      $body.removeClass('has-active-popup');
    }
  });

  const $boxLarge = $('.box-large');

  $window.on('load resize', function() {
    $boxLarge.equalizeHeight();
  })

  $.fn.equalizeHeight = function(){
    var maxHeight = 0, itemHeight;

    this.css('height', '');

    for (var i = 0; i < this.length; i++){
      itemHeight = $(this[i]).height();
      if (maxHeight < itemHeight) {
        maxHeight = itemHeight;
      }
    }

    return this.height(maxHeight);
  };

});
